<div
	class="popover"
	[class.show]="show"
	[class.no-arrow]="!showArrow"
	[ngClass]="'face-' + popoverPlacement[0] + ' pos-' + popoverPlacement[1]"
>
	<div
		class="inner"
		[style.minWidth]="minWidth + 'px'"
		[style.minHeight]="minHeight + 'px'"
		[style.maxWidth]="maxWidth + 'px'"
		[style.maxHeight]="maxHeight + 'px'"
	>
		<ng-content></ng-content>
	</div>
</div>
<div *ngIf="hasBackdrop" class="backdrop" [class.show]="show" (click)="onBackdropClicked()"></div>
